var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.getStatusOutrosClass(_vm.amostra)},[_vm._v(" "+_vm._s(_vm.getStatusOutrosNome(_vm.amostra))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }